const { default: axios } = require("axios");

const movieFetchRequest = (movie_id) => {
  return {
    type: "MOVIE_FETCH_REQUEST",
    payload: movie_id,
  };
};

const movieFetchSuccess = (movie) => {
  return {
    type: "MOVIE_FETCH_SUCCESS",
    payload: movie,
  };
};

const movieFetchFailure = (error) => {
  return {
    type: "MOVIE_FETCH_FAILURE",
    payload: error,
  };
};

const movieFetch = (movie_id) => {
  return (dispatch) => {
    dispatch(movieFetchRequest(movie_id));
    // console.log(dispatch(movieFetchRequest({ movie_id })));
    axios({
      method: "GET",
      url: !movie_id ? "/movies" : `/movies/${movie_id}`,
    })
      .then((response) => {
        const movie = response.data;
        dispatch(movieFetchSuccess(movie));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(movieFetchFailure(errorMsg));
      });
  };
};

export default movieFetch;
